import type { DropdownItem } from "../foundations/option";

/** Default client-side matching shared by the dropdown family. */
export function defaultDropdownFilterOption(option: DropdownItem, query: string): boolean {
  const normalizedQuery = normalizeDropdownSearchText(query);
  if (!normalizedQuery) {
    return true;
  }

  return normalizeDropdownSearchText(
    [option.label, option.description].filter(Boolean).join(" "),
  ).includes(normalizedQuery);
}

function normalizeDropdownSearchText(value: string): string {
  return value.trim().replace(/\s+/g, " ").toLocaleLowerCase();
}
